var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsOptional, IsString, Matches, MaxLength, ValidateIf } from 'class-validator';
import { CALENDAR_DATE } from './calendar-date.js';
/**
 * Records a Befreiungsbescheinigung the patient has presented (#1496).
 *
 * The patient is the route parameter, not a body field. Nothing else is
 * captured: no upload, no scan — keeping the paper is the practice's job.
 *
 * The shape check here is the wire guard only; whether the date is a day that
 * exists is the domain's to say, and it says it again on the way in.
 */
export class CreateCopaymentExemptionDto {
    validFrom;
    /** Last covered day, inclusive. `null` means "bis auf Weiteres". */
    validTo;
    note;
}
__decorate([
    IsString(),
    Matches(CALENDAR_DATE, { message: 'validFrom muss im Format "YYYY-MM-DD" vorliegen' }),
    __metadata("design:type", String)
], CreateCopaymentExemptionDto.prototype, "validFrom", void 0);
__decorate([
    ValidateIf((_, value) => value !== null && value !== undefined),
    IsString(),
    Matches(CALENDAR_DATE, { message: 'validTo muss im Format "YYYY-MM-DD" vorliegen' }),
    __metadata("design:type", Object)
], CreateCopaymentExemptionDto.prototype, "validTo", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(255),
    __metadata("design:type", Object)
], CreateCopaymentExemptionDto.prototype, "note", void 0);
//# sourceMappingURL=create-copayment-exemption.dto.js.map